@use "~theme/typography";

$line-height-fudge-factor: 2px;
$placeholder-icon-padding: 8px;
$placeholder-icon-width: 15px;

@mixin vertically-centered-background {
  position: absolute;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  content: "";
  display: inline-flex;
  align-items: center;
  height: 100%;
  width: $placeholder-icon-width;
}

.wrapper {
  width: 100%;
  position: relative;

  // Reset <button> styles
  font-size: 100%;
  border: none;
  padding: 0;
  margin: 0;

  &::before {
    @include vertically-centered-background;
    pointer-events: none;
    background-image: url("~images/calendar.svg");
    left: $placeholder-icon-padding;
    bottom: $line-height-fudge-factor;
  }

  &::after {
    @include vertically-centered-background;
    pointer-events: none;
    background-image: url("~images/chevron-down.svg");
    right: $placeholder-icon-width - $placeholder-icon-padding;
    bottom: $line-height-fudge-factor;
  }
}

.wrapperIsOpen {
  &::after {
    transform: translateY($line-height-fudge-factor) rotate(180deg);
  }
}

.placeholderInput {
  $wrapper-padding-y: 8px;

  @include typography.heading4;
  appearance: initial;
  background-color: var(--gray-04);
  border: 1px solid var(--blue-01-at-30);
  border-radius: 4px;
  padding: {
    left: (2 * $placeholder-icon-padding) + $placeholder-icon-width;
    right: 16px;
    top: $wrapper-padding-y;
    bottom: $wrapper-padding-y;
  }
  width: 100%;
}
